import { render, staticRenderFns } from "./Education.vue?vue&type=template&id=cdbe3e46&scoped=true"
import script from "./Education.vue?vue&type=script&lang=js"
export * from "./Education.vue?vue&type=script&lang=js"
import style0 from "./Education.vue?vue&type=style&index=0&id=cdbe3e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbe3e46",
  null
  
)

export default component.exports